import axios from 'axios'
// import es6Promise from 'es6-promise'
import qs from 'qs';
import { getUserInfo } from '../common/utils/localStorage.js'

// es6Promise.polyfill();//解决promiseIE不兼容

let instance = axios.create({
    //超时
    timeout: 60000,
    baseURL: process.env.ERP_API,
    // baseURL:'/proxydf/',
    // 设置请求头
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

//获取用户信息
let user = getUserInfo();
if(user && user.token){
    Object.keys(user).forEach(key =>{
        let val = user[key];
        if(val){
            instance.defaults.headers.common[key] = encodeURI(val);
        }
    });
}


// code状态码判断
instance.interceptors.response.use((res) => {
    if (res.data.code === '1000') { 
        console.log('请求异常！');
        return Promise.reject({type: -1, msg: res.data.msg, res: res.data});
    }
    if (res.status === 654) { 
        console.log('请求超时！');
        return Promise.reject({type: -1, msg: "请求超时！", res: res});
    }
    if(res.data.size && res.request.responseType == 'blob'){
        return res.data;
    }
    if (res.data.code == '1006' || res.data.code == '1010' || res.data.code == '1101') {
        // console.log('无权限操作！');
        // Message.info({title:'提示',message: res.errorMsg || res.data.errorMsg || "亲，服务器出小差啦，请稍后重试！", type:'error'});
        return res.data;
    }
    if (res.data.status != 1) {
        return Promise.reject({type: -2, msg: "请求错误！", res: res.data});  //抛出异常
    }
    if (res.data.status != 1) {
        console.log('暂无数据！');
        return Promise.reject({type: 0, msg: res.data.msg || "亲，服务器出小差啦，请稍后重试！", res: res.data});
    }
    return res.data;
}, (error) => {
    console.log('promise error:' + error);
    return Promise.reject({type: -2, msg: "亲，服务器出小差啦，请稍后重试！", res: error})
});

//对POST请求数据做处理
instance.interceptors.request.use((res) => {
    let userInfo = getUserInfo();
    if(!res.headers.token){
        Object.keys(userInfo).forEach(key =>{
            let val = userInfo[key];
            if(val){
                res.headers.common[key] = encodeURI(val);
            }
        });
    }
    if(res.method != "get" && res.method != "delete" && res.data){
        if(res.data.responseType){
            res.responseType = res.data.responseType;
            delete res.data.responseType;
        }
        if(res.headers['Content-Type'] == "application/json"){
            res.data = res.data.params
        }else{
        }
    }
    return res;
});

export default instance;



// WEBPACK FOOTER //
// ./src/api/diyaxios.js